import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground shadow-sm',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        destructive: 'border-transparent bg-destructive text-destructive-foreground shadow-sm',
        success: 'border-transparent bg-success text-success-foreground shadow-sm',
        warning: 'border-transparent bg-warning text-warning-foreground shadow-sm',
        outline: 'text-foreground',
        production: 'border-transparent bg-green-500/10 text-green-600 dark:text-green-400',
        staging: 'border-transparent bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
        testing: 'border-transparent bg-orange-500/10 text-orange-600 dark:text-orange-400',
        training: 'border-transparent bg-cyan-500/10 text-cyan-600 dark:text-cyan-400',
        development: 'border-transparent bg-blue-500/10 text-blue-600 dark:text-blue-400',
        custom: 'border-transparent bg-purple-500/10 text-purple-600 dark:text-purple-400',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
